// extracted by mini-css-extract-plugin
export default {"filterDrawer":"mobile-slider_filterDrawer__xW7S6","headerBar":"mobile-slider_headerBar__oK6kW","title":"mobile-slider_title__CFtvE","resetBtn":"mobile-slider_resetBtn__6DCrM"};